

import { formatCurrencyFull } from "@/lib/data";

interface VendorItem {
  id?: number;
  description?: string;
  vendor_name?: string;
  quantity: number;
  unit_price: number;
}

interface QuotationVendorsTableProps {
  vendors?: VendorItem[];
  quotationVendors?: VendorItem[];
}

export default function QuotationVendorsTable({
  vendors,
  quotationVendors,
}: QuotationVendorsTableProps) {
  const allVendors = vendors || quotationVendors || [];

  return (
    <div className="bg-white rounded-xl border border-stone-200 shadow-sm overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-stone-50 to-white border-b border-stone-200">
        <h2 className="text-lg font-semibold text-stone-800">Vendors</h2>
      </div>
      {allVendors.length > 0 ? (
        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-stone-200">
                  <th className="text-left py-3 px-4 text-sm font-medium text-stone-700">Description</th>
                  <th className="text-center py-3 px-4 text-sm font-medium text-stone-700">Quantity</th>
                  <th className="text-right py-3 px-4 text-sm font-medium text-stone-700">Unit Price</th>
                  <th className="text-right py-3 px-4 text-sm font-medium text-stone-700">Total</th>
                </tr>
              </thead>
              <tbody>
                {allVendors.map((vendor, idx) => (
                  <tr key={idx} className="border-b border-stone-100 hover:bg-stone-50">
                    <td className="py-3 px-4">
                      <p className="font-medium text-stone-800">{vendor.description || vendor.vendor_name || "Vendor"}</p>
                    </td>
                    <td className="py-3 px-4 text-center text-stone-600">{vendor.quantity}</td>
                    <td className="py-3 px-4 text-right text-stone-600">{formatCurrencyFull(vendor.unit_price)}</td>
                    <td className="py-3 px-4 text-right font-semibold text-amber-700">{formatCurrencyFull(vendor.quantity * vendor.unit_price)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="p-6 text-center text-stone-500">
          <p>No vendors added</p>
        </div>
      )}
    </div>
  );
}
